import { useTranslate } from '@tolgee/react';
import { i18nExist } from 'services/i18n/utils';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useCallback } from 'react';
import { toUpperCase } from 'utils/toLowerCase';
import posthog from '@leyan/lytics';

const missingReasonMap: Record<string, boolean> = {};

export const useGetReasonLabel = () => {
  const { t } = useTranslate();

  const getReasonLabel = useCallback(
    (reason: string, platform: General.PlatformUpperCase | any) => {
      const p = isTiKTokUpperCase(toUpperCase(platform)) ? 'TIKTOK' : platform;

      if (
        !i18nExist(`trade_return_reason_${reason}`) &&
        !i18nExist(`ViewDashboard.${p}.${reason}`) &&
        !i18nExist(reason) &&
        !missingReasonMap[reason]
      ) {
        missingReasonMap[reason] = true;
        posthog.capture('$refund_reason_not_found', {
          reason,
          platform,
        });
      }

      return t({
        key: `trade_return_reason_${reason}`,
        defaultValue: t({
          key: `ViewDashboard.${p}.${reason}`,
          defaultValue: i18nExist(reason) ? t(reason) : reason,
        }),
      });
    },
    [t],
  );

  return {
    t,
    getReasonLabel,
  };
};
